<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router";
import type { ParticipationResource } from "@carnet/api/backoffice";

defineProps<{
  items: ParticipationResource[];
  total: number;
  isMobile?: boolean;
  seeAllTo?: RouteLocationRaw;
  tileTo: (participation: ParticipationResource) => RouteLocationRaw;
}>();

const { t } = useI18n();
</script>

<template>
  <AppSection class="bg-elevated" :ui="{ base: 'py-16 lg:py-20' }">
    <div class="flex flex-wrap items-start justify-between gap-x-4 gap-y-6 mb-10">
      <h2 class="text-4xl font-semibold">{{ t("site.activities") }}</h2>
      <UButton v-if="seeAllTo" :to="seeAllTo" variant="outline" trailing-icon="icon:arrowRight">
        {{ t("site.activities.allCount", total, { named: { count: total } }) }}
      </UButton>
    </div>

    <AppCarousel
      v-if="isMobile"
      :items="items"
      :item-key="(participation) => participation.id"
      :cols="{ base: 1 }"
      :label="t('site.activities')"
      overflow-visible
    >
      <template #default="{ item }">
        <AppTileActivity :participation="item" :to="tileTo(item)" />
      </template>
    </AppCarousel>
    <ul v-else role="list" class="space-y-4">
      <li v-for="participation in items" :key="participation.id">
        <AppTileActivity :participation="participation" :to="tileTo(participation)" />
      </li>
    </ul>
  </AppSection>
</template>
